import { $globalSanityClient } from '@/sanity';
import { profilesQuery } from './profilesQuery';
import UIProfileListingSection from './ProfileListingSection.client';

export default async function DiseaseListingSection() {
  const profiles = await $globalSanityClient.fetch<(typeof profilesQuery)[1]>(
    profilesQuery[0]
  );

  const filtered = profiles.filter((profile) => !profile.hideFromListing);

  return <UIProfileListingSection profiles={filtered} />;
}
